// extracted by mini-css-extract-plugin
module.exports = {"service":"service-list_service_3WRp8","title":"service-list_title_2UCqI","label":"service-list_label_1Y1b7"};